/* eslint-disable */

import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getRequest } from '../Helpers/Requests'
import OcpiSessions from '../../../_metronic/partials/widgets/tables/OcpiSessions'
import OcpiCdr from '../../../_metronic/partials/widgets/tables/OcpiCdr'
import GetSupportedVersion from '../../../_metronic/partials/modals/OCPI/GetSupportedVersion'
import GetVersionDetails from '../../../_metronic/partials/modals/OCPI/GetVersionDetails'
import InititateHandshake from '../../../_metronic/partials/modals/OCPI/InititateHandshake'
import PushLocation from '../../../_metronic/partials/modals/OCPI/PushLocation'
import PushTariff from '../../../_metronic/partials/modals/OCPI/PushTariff'



const EmobilitesDetails = () => {
  let { pointId } = useParams()
  const [data, setData] = useState<any>(null)
  const [versions, setVersions] = useState()

  const getData = async () => {
    try {
      const response = await getRequest(`/ocpi/msp/${pointId}`)
      console.log('response', response?.data)
      if (response && response.data) {
        setData(response.data.data)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const getVersionData = async () => {
    try {
      const res = await getRequest(`/ocpi/msp/${pointId}/versions`)
      console.log('versions response', res)
      if (res && res.data) {
        setVersions(res.data.data)
      }
    } catch (error: any) {
      console.error('Error fetching data:', error)
    }
  }

  useEffect(() => {
    getData()
  }, [pointId])

  return (
    <div>
      <div className='card mb-0 mb-xl-2' id='kt_profile_details_view'>
        <div className='card-body p-5'>
          <div className='card mb-6'>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap'>
                <div className='me-7 mb-4'>
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img src='/media/avatars/blank.png' alt='image' />
                    {/* <div
                      className={`position-absolute translate-middle bottom-0 start-100 mb-6 ${
                        cmsUsers?.status === 1 ? 'bg-success' : 'bg-danger'
                      } rounded-circle border border-4 border-body h-20px w-20px`}
                    /> */}
                  </div>
                </div>
                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <a className='text-gray-900 text-hover-primary fs-2 fw-bold me-1'>
                          {data?.business_name}
                        </a>
                        <a>
                          <i className='ki-outline ki-verify fs-1 text-primary' />
                        </a>
                      </div>
                      <div className='d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2'>
                        <a className='d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2'>
                          <i className='ki-outline ki-geolocation fs-4 me-1' />
                          {data?.party_id}
                        </a>
                        <a className='d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2'>
                          <i className='ki-outline ki-geolocation fs-4 me-1' />
                          {data?.country_code}
                        </a>
                      </div>
                    </div>
                    <div className='d-flex my-4'>
                      {data?.status === 'ACTIVE' ? (
                        <a className={`btn btn-sm btn-success me-3`}>Active</a>
                      ) : (
                        <a className={`btn btn-sm btn-danger me-3`}>Inactive</a>
                      )}
                    </div>
                  </div>
                  <div className='d-flex flex-wrap flex-stack'>
                    <div className='d-flex flex-column flex-grow-1 pe-8'>
                      <div className='d-flex flex-wrap'>
                        {/* <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <i className='ki-outline ki-arrow-down fs-3 text-danger me-2' />{' '}
                            <div
                              className='fs-2 fw-bold counted'
                              data-kt-countup='true'
                              data-kt-countup-value={80}
                              data-kt-initialized={1}
                            >
                              {cmsUsers?.AMCend ? cmsUsers?.AMCend : 'Null'}
                            </div>
                          </div>
                          <div className='fw-semibold fs-6 text-gray-500'>AMC End date</div>
                        </div> */}
                        {/* <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <i className='ki-outline ki-arrow-up fs-3 text-success me-2' />{' '}
                            <div
                              className='fs-2 fw-bold counted'
                              data-kt-countup='true'
                              data-kt-countup-value={60}
                              data-kt-countup-prefix='%'
                              data-kt-initialized={1}
                            >
                              {cmsUsers?.AMCstart ? cmsUsers?.AMCstart : 'Null'}
                            </div>
                          </div>
                          <div className='fw-semibold fs-6 text-gray-500'>AMC Start Date</div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold'>
                <li className='nav-item'>
                  <a
                    className='nav-link active text-active-success py-5 me-6'
                    data-bs-toggle='tab'
                    href='#kt_tab_pane_1'
                  >
                    Sessions
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className='nav-link text-active-success py-5 me-6'
                    data-bs-toggle='tab'
                    href='#kt_tab_pane_2'
                  >
                    Cdrs
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className='nav-link text-active-success py-5 me-6'
                    data-bs-toggle='tab'
                    href='#kt_tab_pane_3'
                  >
                    Logs
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className='nav-link text-active-success py-5 me-6'
                    data-bs-toggle='tab'
                    href='#kt_tab_pane_4'
                  >
                    Manage
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='cartd-body p-5'>
          <div className='tab-content' id='myTabContent'>
            <div className='tab-pane fade show active' id='kt_tab_pane_1' role='tabpanel'>
              <OcpiSessions />

            </div>
            <div className='tab-pane fade' id='kt_tab_pane_2' role='tabpanel'>
              <OcpiCdr />
            </div>
            <div className='tab-pane fade' id='kt_tab_pane_3' role='tabpanel'>
              {/* <TransactionCPO stations={stations} /> */}
            </div>
            <div className='tab-pane fade' id='kt_tab_pane_4' role='tabpanel'>
              <div className='d-flex flex-wrap flex-stack'>
                <div className='d-flex flex-column flex-grow-1'>
                  <div className='d-flex flex-wrap'>
                    <div
                      className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 cursor-pointer bg-secondary'
                      data-bs-toggle='modal'
                      data-bs-target='#get_supported_version'
                      onClick={() => getVersionData()}
                    >
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bold counted'
                          data-kt-countup='true'
                          data-kt-countup-value={60}
                          data-kt-countup-prefix='%'
                          data-kt-initialized={1}
                        >
                          GET
                        </div>
                      </div>
                      <div className='fw-semibold fs-6 text-gray-500'>Get Supported Version</div>
                    </div>
                    <div
                      className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 cursor-pointer bg-secondary'
                      data-bs-toggle='modal'
                      data-bs-target='#get_version_details'
                    >
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bold counted'
                          data-kt-countup='true'
                          data-kt-countup-value={60}
                          data-kt-countup-prefix='%'
                          data-kt-initialized={1}
                        >
                          GET
                        </div>
                      </div>
                      <div className='fw-semibold fs-6 text-gray-500'>Version Details</div>
                    </div>
                    <div
                      className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 cursor-pointer bg-secondary'
                      data-bs-toggle='modal'
                      data-bs-target='#get_initiate_handshake'
                    >
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bold counted'
                          data-kt-countup='true'
                          data-kt-countup-value={60}
                          data-kt-countup-prefix='%'
                          data-kt-initialized={1}
                        >
                          GET
                        </div>
                      </div>
                      <div className='fw-semibold fs-6 text-gray-500'>Inititate Handshake</div>
                    </div>
                    <div
                      className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 cursor-pointer bg-secondary'
                      data-bs-toggle='modal'
                      data-bs-target='#get_push_location'
                    >
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bold counted'
                          data-kt-countup='true'
                          data-kt-countup-value={60}
                          data-kt-countup-prefix='%'
                          data-kt-initialized={1}
                        >
                          PUSH
                        </div>
                      </div>
                      <div className='fw-semibold fs-6 text-gray-500'>Push Location</div>
                    </div>
                    <div
                      className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 cursor-pointer bg-secondary'
                      data-bs-toggle='modal'
                      data-bs-target='#get_push_tariff'
                    >
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bold counted'
                          data-kt-countup='true'
                          data-kt-countup-value={60}
                          data-kt-countup-prefix='%'
                          data-kt-initialized={1}
                        >
                          PUSH
                        </div>
                      </div>
                      <div className='fw-semibold fs-6 text-gray-500'>Push Tariff</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GetSupportedVersion data={versions} />
      <GetVersionDetails />
      <InititateHandshake />
      <PushLocation />
      <PushTariff />
    </div>
  )
}

export default EmobilitesDetails
